export const searchUrlParameters = {
  ANSWERS: 'answers',
  WEIGHTS: 'weights',
}
